import { useSyncExternalStore } from "react"

export type ConnectionState = "connecting" | "live" | "reconnecting"

let state: ConnectionState = "connecting"
const listeners = new Set<() => void>()

/** Feed connection state shared with the shell banner (screen 49: connection interrupted). */
export function setConnectionState(next: ConnectionState) {
  if (state === next) return
  state = next
  for (const listener of listeners) listener()
}

export function useConnectionState(): ConnectionState {
  return useSyncExternalStore<ConnectionState>(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => state,
    () => "live"
  )
}
